/* Raw Organics - custom.js
   Gemmer scroll-position + sidehoejde for kollektionssider (pr. URL, sessionStorage).
   Selve gendannelsen ved tilbage-navigation sker i inline-scriptet i snippets/head.liquid. */
(function () {
  try {
    if (!document.body || !document.body.classList.contains('template-collection')) return;
    var key = 'ro-scroll:' + location.pathname + location.search;
    var timer = null;
    var lastY = 0;

    var save = function (fromPagehide) {
      try {
        var y = Math.round(window.pageYOffset || window.scrollY || 0);
        var h = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
        if (y === 0) {
          /* iOS nulstiller scroll under sidens nedlukning - stol aldrig paa pludselige 0'er */
          if (fromPagehide) return;
          if (document.visibilityState === 'hidden') return;
          if (lastY > 800) return;
        }
        lastY = y;
        sessionStorage.setItem(key, JSON.stringify({ y: y, h: h }));
      } catch (e) {}
    };

    window.addEventListener('scroll', function () {
      if (window.__roRestoring) return;
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { save(false); }, 150);
    }, { passive: true });

    /* sidste ord inden man forlader siden - men kun hvis laesningen er trovaerdig */
    window.addEventListener('pagehide', function () {
      save(true);
    });
  } catch (e) { /* maa aldrig paavirke resten af siden */ }
})();

/* RO Judge.me German sort-label fix */
(function () {
  if ((document.documentElement.lang || '').toLowerCase().indexOf('de') !== 0) return;
  var source = 'Sort reviews by';
  var target = 'Bewertungen sortieren nach';

  function translate(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var labels = [];
    if (scope.matches && scope.matches('label.jdgm-visually-hidden')) labels.push(scope);
    if (scope.querySelectorAll) labels = labels.concat(Array.from(scope.querySelectorAll('label.jdgm-visually-hidden')));
    labels.forEach(function (label) {
      if ((label.textContent || '').trim() === source) label.textContent = target;
    });
  }

  function start() {
    translate(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) translate(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
